import { InfiniteData } from '@tanstack/react-query'

export const flattenInsertionOrderPages = (
  data: InfiniteData<ListInsertionOrdersResponse, number> | undefined
): InsertionOrder[] => {
  if (!data?.pages) return []

  return data?.pages?.flatMap(page => page?.data ?? []) || []
}
